// JsFromRoutes CacheKey f9c6f11ae385a9cfc5486f7a2f474b72
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  sendTestEmail: /* #__PURE__ */ definePathHelper('post', '/testing_tools/add_friends/prompt/send_test_email'),
  create: /* #__PURE__ */ definePathHelper('post', '/testing_tools/add_friends/prompt'),
}
